<template>
<div class="login">
    <h1 v-if="showLoginForm" class="subheading grey--text">Login</h1>
    <h1 v-if="showForgotPassword" class="subheading grey--text">Glemt password</h1>
    <v-layout row wrap>
        <v-flex xs12 sm6 md4>
            <v-form v-if="showLoginForm" class="" ref="form">
                <v-text-field label="E-mail" v-model="email"></v-text-field>
                <v-text-field label="Password" :type="show1 ? 'text' : 'password'" v-model="password" :append-icon="show1 ? 'visibility_off' : 'visibility'" @click:append="show1 = !show1">
                </v-text-field>
                <v-alert v-model="showAlert" color="error">
                    {{message}}.
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn flat class="success mx-0 mt-3" @click="login" :loading="loading">Login</v-btn>

                <div class="extras">
                    <a @click="togglePasswordReset">Glemt Password</a>
                    <v-spacer></v-spacer>
                    <a @click="$router.push({ name: 'signup'})">Opret bruger</a>
                </div>

            </v-form>

            <form v-if="showForgotPassword" @submit.prevent class="password-reset">
                <div v-if="!passwordResetSuccess">

                    <p>Der vil blive sendt en email met et link som giver dig mulighed for at ændre password</p>

                    <v-text-field label="E-mail" v-model.trim="passwordForm.email"></v-text-field>

                    <v-btn flat class="success mx-0 mt-3" @click="resetPassword" :loading="loading">Send</v-btn>

                    <div class="extras">
                        <a @click="togglePasswordReset">Tilbage til login</a>
                    </div>
                </div>
                <div v-else>
                    <h1>Email afsendt</h1>
                    <p>Check din email for et link til at ændre dit password</p>
                    <button @click="togglePasswordReset" class="button">Tilbage til login</button>
                </div>
            </form>

        </v-flex>
        <!--    <v-flex >
            <v-btn flat class="mx-0 mt-3 facebook-login" color="white" @click="socialLogin" ><img class="facebook-login-img" src="/img/icons/facebook.png" width="18" height="18"/>Login med facebook</v-btn>
        </v-flex>-->
    </v-layout>
</div>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase'
var provider = new firebase.auth.FacebookAuthProvider();
export default {
    data() {
        return {
            show1: false,
            showAlert: false,
            message: 'test',
            email: '',
            password: '',
            loading: false,
            showForgotPassword: false,
            passwordResetSuccess: false,
            showLoginForm: true,
            passwordForm: {
                email: ''
            },
        }
    },
    methods: {
        resetPassword() {
            this.performingRequest = true
            firebase.auth().sendPasswordResetEmail(this.passwordForm.email).then(() => {
                this.performingRequest = false
                this.passwordResetSuccess = true
                this.passwordForm.email = ''
            }).catch(err => {
                console.log(err)
                this.performingRequest = false
                this.errorMsg = err.message
            })
        },
        toggleForm() {
            this.errorMsg = ''
            this.showLoginForm = !this.showLoginForm
        },
        togglePasswordReset() {
            if (this.showForgotPassword) {
                this.showLoginForm = true
                this.showForgotPassword = false
                this.passwordResetSuccess = false
            } else {
                this.showLoginForm = false
                this.showForgotPassword = true
            }
        },

        login() {

            if (this.email && this.password) {
                this.loading = true;
                this.showAlert = false;

                firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                    .then(cred => {

                    }).then(() => {
                        this.$store.dispatch('setAuthUser').then(() => {
                            this.$store.dispatch('setProfile', {
                                vm: this
                            })
                        })
                        this.$router.push({
                            name: 'dashboard'
                        })
                    })
                    .catch(err => {
                        this.message = err.message
                        this.showAlert = true
                        this.loading = false
                    })
            } else {
                this.message = "Udfyld både email og password"
                this.showAlert = true

            }
        },
    }
}
</script>

 
<style>
.facebook-login {
    background-color: #4267b2;
    text-transform: none;
}

.facebook-login-img {
    margin-right: 5px;
}
</style>
